import PublicRoutes from "./routes/PublicRoutes";
import "../src/assets/css/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import { useEffect } from "react";
import { dripe_mobile, drive_mobile, footer_mobile } from "./constant";
import $ from "jquery";
import { ToastContainer , toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {
  useEffect(() => {
    if (window.innerWidth <= "480") {
      $(".footer-card-wrapper .footer-img-wrapper img").attr(
        "src",
        footer_mobile
      );
      $(".sec-about .about-card-wrapper .about-img-wrapper img").attr(
        "src",
        drive_mobile
      );
    }
  }, []);


  return (
    <>
      <div id="loader-full" className="loader-full">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
      <ToastContainer  />
      <PublicRoutes />
    </>
  );
}

export default App;
